var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    attrs: {
      "id": "footer"
    }
  }, [_c('p', [_vm._v("Graham Bartley " + _vm._s(_vm.currentYear) + " - Hosted by "), _c('a', {
    attrs: {
      "href": "https://pages.github.com/",
      "target": "_blank",
      "rel": "noreferrer nofollow"
    }
  }, [_vm._v("GitHub Pages")])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b5a1f42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyFooter.vue
// module id = TrHY
// module chunks = 0